import d from "dayjs";

export const isBetweenMidnightAndBreakTime = (
  start: string | Date | d.Dayjs,
  breakTime: string | Date | d.Dayjs
) => {
  const startHour = d(start).get("hour");
  const breakHour = d(breakTime).get("hour");
  return startHour >= 0 && startHour < breakHour;
};
